import React from 'react';
import styled from 'styled-components';
import { SmallSectionHeader, ShortBody } from 'components/Typography';

export const StyledtBlocWrapper = styled(({ height, ...otherProps }) => (
  <div {...otherProps} />
))`
  height: ${(props) => props.height};
`;

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
export const StyledBodyText = styled(ShortBody)`
  white-space: pre-line;
  color: #162952 !important;
  font-size: 14px !important;
  line-height: 24px !important;
  max-height: 500px !important;
  margin-top: 30px !important;
  margin-bottom: 35px !important;
`;
